<template>

  <v-row class="justify-center mb-12">
    <v-col cols="12">
      <div :style="QuestionXOfNbStyle" class="questionXofNb">Frage {{ questionIndex }} von 6</div>
      <h1 v-if="questionTitle" style="text-align: center">{{ questionTitle }}</h1>
      <v-row :class="$vuetify.breakpoint.mdAndUp ? 'mt-5' : 'mt-2'" class="justify-center">
        <v-col cols="12">
          <p class="infoText">
            <fin-lexicon-text
              auto-solve
              v-if="question"
              :text="question"/>
            <fin-info-icon v-if="hint" :alertTexts="hint" class="ml-1" color="fin-color-primary-dark"/>
          </p>
        </v-col>
        <v-col :style="$vuetify.breakpoint.mdAndUp ? 'font-size: 1.4em' : 'font-size: 1em'" class="pa-0"
               cols="12">
          <slot/>
        </v-col>
        <v-col cols="12" v-if="$vuetify.breakpoint.mdAndUp"
               :style="$vuetify.breakpoint.mdAndUp ? 'font-size: 1.4em' : 'font-size: 1em'">
          <!--fin-lexicon-text auto-solve style="height: 70px" :text="selectionHint" />-->
          <v-btn :dark="selectable"
                 :disabled="!selectable"
                 style="border-radius: 0; z-index: 99"
                 @click.native="$emit('next')">
            Weiter
          </v-btn>
        </v-col>
      </v-row>
    </v-col>
    </v-row>

</template>

<script>
import FinLexiconText from '@/components/common/lexicon/LexiconText/index'
import FinInfoIcon from "../../../../../common/InfoIcon/index"
import {Analytics} from "@/plugins/finAmplifyModules"

export default {
  name: 'FinStepByStepQuestion',
  components: {FinInfoIcon, FinLexiconText},
  props: {
    value: {
      type: Number
    },
    selectable: {
      type: Boolean
    },
    questionTitle: {
      type: String
    },
    question: {
      type: String
    },
    hint: {
      type: Object
    },
    selectionHint: {
      type: String
    },
    questionIndex: {
      type: Number
    }
  },
  data() {
    return {
      marginBottom: '5%'
    }
  },
  methods: {
    showHint() {
      this.$alert(this.hint)
    }
  },
  computed: {
    QuestionXOfNbStyle() {
      const bp = this.$vuetify.breakpoint
      let fs = 1.4

      if (bp.smAndDown) {
        fs = 1
      }

      const style = {
        fontSize: fs + 'em'
      }

      return style
    },
    introRowStyle() {
      const bp = this.$vuetify.breakpoint
      let mb = 48

      if (bp.smAndDown) {
        mb = 12
      }

      const style = {
        marginBottom: mb + 'px'
      }

      return style
    }
  },
  mounted() {
    Analytics.record({
      name: 'fincraft_preview_step_viewed',
      // Attribute values must be strings
      attributes: {step: 'q' + this.questionIndex, question: this.questionTitle}
    })
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../../../styles/variables.scss";

.questionXofNb {
  color: $fin-color-cool-grey
}

h1 {
  @media only screen and (max-width: 960px) {
    font-size: 28px;

  }
}

.infoText {
  @media only screen and (max-width: 960px) {
    font-size: 16px;
  }
}
</style>
